import { h, render, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import { route } from 'preact-router';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import ViewFields from '../../components/form/viewFields';
import Input from '../../components/form/input';
import DyrejournalAnimalListMini from '../../components/dyrejournal/listAnimalMini';
import DyrejournalPrescriptionListMini from '../../components/dyrejournal/listPrescriptionMini';
import DyrejournalSalePrescription from '../../components/dyrejournal/salePrescription';

@withText(props => ({
    emailTitle: <Text id='dyrejournal.email-title'>Email address</Text>,
}))
@observer
class EmailPrescription extends Component {
	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('journal', 'Journal basics'),
            sectionsMedical: fields.get('journal', 'Journal medical'),
            sectionsClinical: fields.get('journal', 'Journal clinical'),
        };
        this.searchTimer = null;
    }

    loadAll = async (props = this.props, emptyFirst = true) => {
        const { id } = props;
        const { prescriptionStore } = this.props.stores;
        await this.loadPrescription(id);
        await prescriptionStore.loadVeterinaries();
    }

    loadPrescription = async id => {
        const { prescriptionStore, animalStore } = this.props.stores;
        await prescriptionStore.load(id);
        const { animal } = prescriptionStore;
        if (animal) {
            await animalStore.load(animal);
        }
    }

    searchInput = (e) => {
        const search = e.target.value;
        this.setState({ search });

        clearTimeout(this.searchTimer);
        if (search.length >= 3) {
            this.searchTimer = setTimeout(async () => {
                this.doSearch(search);
            }, 300);
        }
    }

    async doSearch(search) {
        // return;
        const { contactStore } = this.props.stores;
        if (search) {
            // console.log('doUpdateField.saveField', id, field, value);
            const result = await contactStore.load({ query: { search }, limit: 500, skipUpdate: false });
        }
    }

    clearSearch = () => {
        const { contactStore } = this.props.stores;
        this.setState({ search: '' });
        contactStore.updateKeyValue('contacts', []);
        this.doSearch('');
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.doSearch(this.state.search);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            this.clearSearch();
        }
    }

    onClickEmailPrescription = async e => {
        const { prescriptionStore, visitorStore } = this.props.stores;
        const {
            prescription,
            currentAnimal = {},
            currentVisitor = {},
            journal,
            sale,
        } = this.props;
        const { search, emailComment, farmacy = '', resolvedVisitor = {}, vetRefCode } = this.state;
        // Remember the email against the visitor that owns this prescription
        // (prescription.journal -> journal.visitor), not just the sale's first visitor.
        const prescriptionVisitor = resolvedVisitor.id ? resolvedVisitor : currentVisitor;
        this.setState({ sending: true });
        await prescriptionStore.emailPrescription(prescription.id, search, prescriptionVisitor.id, currentAnimal.id, prescription.journal || journal, sale, emailComment, vetRefCode);
        // console.log('onClickEmailPrescription', prescription.id, search);
        try {
            localStorage.setItem('dyrejournal_lastPrescriptionRecipient', JSON.stringify({ search, farmacy }));
        } catch (err) {
            // ignore localStorage errors (quota, private mode)
        }
        if (prescriptionVisitor.id) {
            try {
                await visitorStore.saveField(prescriptionVisitor.id, 'lastPrescriptionEmail', search || '', true);
                await visitorStore.saveField(prescriptionVisitor.id, 'lastPrescriptionFarmacy', farmacy || '', true);
                // Keep the in-memory copy fresh so reopening within the session recalls it.
                this.setState({
                    resolvedVisitor: {
                        ...prescriptionVisitor,
                        lastPrescriptionEmail: search || '',
                        lastPrescriptionFarmacy: farmacy || '',
                    },
                });
            } catch (err) {
                // ignore — localStorage already holds a system-wide fallback
            }
        }
        this.setState({ sending: false, emailSent: true });
    }

    onClickContact = e => {
        const { contactStore } = this.props.stores;
        const {
            email,
            name = '',
            address = '',
            postalcode = '',
            postalplace = '',
        } = e.target.closest('tr').dataset;
        this.setState({
            search: email,
            farmacy: `${name}\n${address}\n${postalcode} ${postalplace}`,
        }, () => {
            contactStore.updateKeyValue('contacts', []);
        });
    }

    onClickEditContact = e => {
        e.preventDefault();
        e.stopPropagation();
        const {
            id,
        } = e.target.closest('tr').dataset;
        const { drawerLevel = 1 } = this.props;
        const { appState, contactStore } = this.props.stores;
        const { drawerHeightMedium } = appState;
        appState.openDrawer('editContact', {
            height: drawerHeightMedium,
            id,
            callback: () => {
                appState.toggleDrawer(false, drawerLevel + 1);
            },
        }, drawerLevel + 1);
    }

    onClickSendSms = async e => {
        e.preventDefault();
        e.stopPropagation();
        const { id } = e.target.closest('button').dataset;
        const { drawerLevel = 1 } = this.props;
        const { appState, saleStore, userStore } = this.props.stores;
        const { drawerHeightMedium } = appState;
        const { customer } = userStore;
        const { newSale } = saleStore;
        const { visitors = [] } = newSale;
        const { farmacy = '' } = this.state;
        console.log('visitors', visitors);
        appState.openDrawer('sendSms', {
            height: drawerHeightMedium,
            users: visitors,
            message: `Hei,

Vi har sendt resepten på e-post til apoteket.

Vennligst hent medisinene dine hos:
${farmacy || 'apoteket ditt'}.

Mvh,
${customer.name}
`,

            callback: () => {
                appState.toggleDrawer(false, drawerLevel + 1);
            },
        }, drawerLevel + 1);
    }

    // Resolve the visitor that owns this prescription: prescription.journal ->
    // journal.visitor -> the matching visitor object. Reads the already-hydrated
    // saleStore.newSale arrays when available, otherwise loads journal/visitor by id.
    // Falls back to the sale's first visitor (the currentVisitor prop).
    resolveVisitor = async () => {
        const { prescription = {}, journal, currentVisitor = {} } = this.props;
        const { saleStore, journalStore, visitorStore } = this.props.stores;
        const { newSale = {} } = saleStore;
        const { journals = [], visitors = [] } = newSale;

        const journalId = prescription.journal || journal;
        let journalObj = journalId ? journals.find(j => `${j.id}` === `${journalId}`) : null;
        if (!journalObj && journalId) {
            const loaded = await journalStore.load({ query: { id: journalId }, skipUpdate: true });
            journalObj = loaded?.[0];
        }

        const visitorId = journalObj?.visitor;
        let resolvedVisitor = null;
        if (visitorId) {
            resolvedVisitor = visitors.find(v => v.id === visitorId);
            if (!resolvedVisitor) {
                const loaded = await visitorStore.load({ query: { id: visitorId }, skipUpdate: true });
                resolvedVisitor = loaded?.[0];
            }
        }

        return resolvedVisitor && resolvedVisitor.id ? resolvedVisitor : currentVisitor;
    }

    async componentDidMount() {
        this.loadAll();
        const resolvedVisitor = await this.resolveVisitor();
        this.setState({ resolvedVisitor });

        // Don't override anything the user has already typed.
        if (this.state.search) {
            return;
        }
        if (resolvedVisitor.lastPrescriptionEmail) {
            this.setState({
                search: resolvedVisitor.lastPrescriptionEmail,
                farmacy: resolvedVisitor.lastPrescriptionFarmacy || '',
            });
            return;
        }
        try {
            const stored = localStorage.getItem('dyrejournal_lastPrescriptionRecipient');
            if (stored) {
                const { search, farmacy } = JSON.parse(stored);
                if (search) {
                    this.setState({ search, farmacy });
                }
            }
        } catch (err) {
            // ignore localStorage/parse errors
        }
    }

    render() {
        const {
            week,
            isNew,
            hideAdmin = true,
            drawerLevel = 1,
            emailTitle,
            prescription,
            currentAnimal = {},
            currentVisitor = {},
            journal,
            sale,
        } = this.props;
        const {
            search,
            sending,
            emailSent,
        } = this.state;
        const { userStore, contactStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { contacts } = contactStore;

        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    <div class='font-weight-lighter px-3 box-header'>
                        <Text id='dyrejournal.prescription.email'>Email Prescription</Text>
                    </div>

                    <DyrejournalPrescriptionListMini
                        classNames='mx-3'
                        stores={this.props.stores}
                        prescriptions={[prescription]}
                        saleIsLocked={true}
                        drawerLevel={drawerLevel}
                        showButtons={false}
                    />

                    <div class={`d-flex flex-column mt-4 mx-3 px-4 py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>

                        <div class='d-flex flex-row justify-content-between'>
                            <div class='input-group'>
                                <div class='input-group-text rounded-pill-left'>
                                    <i class='fa-regular fa-at'></i>
                                </div>
                                <input
                                    class={`form-control ${!search ? 'rounded-pill-right' : ''}`}
                                    type='text'
                                    value={search}
                                    placeholder={`${emailTitle}`}
                                    onInput={this.searchInput}
                                    onKeyDown={this.handleKeyDown}
                                />
                                {search && <>
                                    <button class='btn btn-danger btn-sm rounded-pill-right' type='button' onClick={this.clearSearch}>
                                        <i class='fa-solid fa-circle-xmark'></i>
                                    </button>
                                </>}
                            </div>
                        </div>

                        {contacts && contacts.length > 0 && <>
                            <div class='d-flex w-100'>
                                <div class='table-responsive'>
                                    <table class={`table table-sm table-hover ${darkmode ? 'table-dark' : 'table-light'}`}>
                                        <thead>
                                            <tr>
                                                <th>&nbsp;</th>
                                                <th><Text id='input.name'>Name</Text></th>
                                                <th><Text id='input.email'>Email</Text></th>
                                                <th><Text id='input.cellphone'>Cellphone</Text></th>
                                                <th><Text id='input.description'>Description</Text></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contacts.map(contact => {
                                                return <tr
                                                    data-email={contact.email}
                                                    data-name={contact.name}
                                                    data-address={contact.address}
                                                    data-postalcode={contact.postalcode}
                                                    data-postalplace={contact.postalplace}
                                                    data-id={contact.id}
                                                    onClick={this.onClickContact}
                                                >
                                                    <td class='d-none d-sm-table-cell' onClick={this.onClickEditContact}>
                                                        <i class='fa-solid fa-pen' />
                                                    </td>
                                                    <td>{contact.name || `${contact.firstname || ''} ${contact.lastname || ''}`.trim()}</td>
                                                    <td>{contact.email}</td>
                                                    <td>{contact.cellphone}</td>
                                                    <td>{contact.description}</td>
                                                </tr>;
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </>}

                        <div class='form-group mt-3'>
                            <label><Text id='dyrejournal.prescription-ref-code'>Our ref code</Text></label>
                            <input
                                class='form-control'
                                type='text'
                                value={this.state.vetRefCode}
                                onInput={e => this.setState({ vetRefCode: e.target.value })}
                            />
                            <small class='text-body-secondary'>
                                <Text id='dyrejournal.prescription-ref-code-help'>Shown as "Our ref code" on the prescription and overrides the veterinarian's default code. Handy when the code differs from pharmacy to pharmacy. Leave blank to use the veterinarian's code.</Text>
                            </small>
                        </div>

                        <div class='form-group mt-3'>
                            <label><Text id='dyrejournal.prescription-comment'>Email comment</Text></label>
                            <textarea
                                class='form-control'
                                rows='3'
                                value={this.state.emailComment}
                                onInput={e => this.setState({ emailComment: e.target.value })}
                            />
                        </div>

                        <button
                            disabled={sending}
                            class={`btn btn-primary ms-2 rounded-pill mt-2`}
                            onClick={this.onClickEmailPrescription}
                        >
                            {sending && <i class='fa-solid fa-circle-notch fa-spin me-2' />}
                            <i class='fa-solid fa-paper-plane' /> <Text id='dyrejournal.email-prescription'>Email prescription</Text>
                        </button>

                        {emailSent && <>
                            <div class='alert alert-success mt-2'>
                                <Text id='dyrejournal.email-sent'>Email sent</Text>
                            </div>
                            <button
                                disabled={sending}
                                class={`btn btn-outline-primary ms-2 rounded-pill mt-2`}
                                onClick={this.onClickSendSms}
                            >
                                {sending && <i class='fa-solid fa-circle-notch fa-spin me-2' />}
                                <i class='fa-solid fa-phone' /> <Text id='dyrejournal.send-sms'>Send SMS to customer</Text>
                            </button>
                        </>}
                    </div>
                </div>

            </div>
        );
    }
}

export default EmailPrescription;
